import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/page/home'


Vue.use(Router)

const router  = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    }
  ]
});
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;

  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;

  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js